import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_META: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'Hogcloud | Website Development, 3D Printing, and Custom Apps',
    description:
      'Hogcloud builds custom websites, business apps, cloud solutions, and 3D printed products in Fayetteville, Arkansas.',
  },
  '/services': {
    title: 'Website Development, Custom App Development, and 3D Printing | Hogcloud',
    description:
      'Explore Hogcloud services for website development, custom app development, cloud applications, AI automation, and custom 3D printing.',
  },
  '/contact': {
    title: 'Contact Hogcloud | Website Development, Custom Apps, and 3D Printing',
    description:
      'Contact Hogcloud for custom websites, business app development, cloud consulting, and custom 3D printing projects.',
  },
  '/shop': {
    title: 'Custom 3D Printed Products | Hogcloud',
    description:
      'Shop Hogcloud custom 3D printed gifts, magnets, jewelry, decorations, party favors, and personalized product ideas.',
  },
};

const setMetaContent = (selector: string, content: string) => {
  const element = document.head.querySelector<HTMLMetaElement>(selector);
  if (element) {
    element.content = content;
  }
};

const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageMeta = PAGE_META[pathname] || PAGE_META['/'];
    const canonicalUrl = `https://hogcloud.net${pathname === '/' ? '/' : pathname}`;

    document.title = pageMeta.title;
    setMetaContent('meta[name="description"]', pageMeta.description);
    setMetaContent('meta[property="og:title"]', pageMeta.title);
    setMetaContent('meta[property="og:description"]', pageMeta.description);
    setMetaContent('meta[property="og:url"]', canonicalUrl);
    setMetaContent('meta[name="twitter:title"]', pageMeta.title);
    setMetaContent('meta[name="twitter:description"]', pageMeta.description);

    const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) {
      canonical.href = canonicalUrl;
    }
  }, [pathname]);

  return null;
};

export default SEO;
